import * as React from 'react';
import {Trans, useTranslation} from '@deviceinsight/ng-ui-scale-lib/api';
import dayjs from 'dayjs';
import DateTimeInput from '../../common/DateTimeInput';
import type {CreateJobFormData} from '../types';
import '../types';
import {ADMIN_CREATE_TEST_IDS} from '../consts';
import './JobDetailsForm.less';
import getAtLeastOneVariantDefined from './getAtLeastOneVariantDefined';
type Props = {
	heading: {
		i18nKey: string;
		defaultValue: string;
	};
	formData: CreateJobFormData;
	setFormData: (arg0: CreateJobFormData) => void;
};

const JobDetailsForm = ({heading, setFormData, formData}: Props) => {
	const {t} = useTranslation();
	// Use a default latest execution date only if none is currently set.
	const defaultLatestExecutionDate =
		formData.latestExecutionDate || dayjs().add(14, 'day').hour(0).minute(0).toISOString();

	const minDate = new Date();
	const atLeastOneVariantDefined = getAtLeastOneVariantDefined(formData);

	if (!atLeastOneVariantDefined) {
		return null;
	}

	const descriptionPlaceholder = t('updatejobs.create.descriptionPlaceholder', {
		defaultValue: 'Enter a description'
	});

	return (
		<>
			<h2 className="di header dividing">
				<Trans i18nKey={heading.i18nKey}>{heading.defaultValue}</Trans>
			</h2>
			<div className="di form job-details">
				<div data-testid={ADMIN_CREATE_TEST_IDS.DATE_SELECT} className="field date-select">
					<label>
						<Trans i18nKey="updatejobs.create.latestExecutionDate">Latest Execution date</Trans>
					</label>
					<DateTimeInput
						step={30}
						minDate={minDate}
						timestamp={formData.latestExecutionDate || defaultLatestExecutionDate}
						onChange={(date: string | null | undefined) => {
							// Preserve the selected value; if date is null/undefined, keep previous or fallback to default.
							setFormData({
								...formData,
								latestExecutionDate: date ?? formData.latestExecutionDate ?? defaultLatestExecutionDate
							});
						}}
					/>
				</div>
				<div data-testid={ADMIN_CREATE_TEST_IDS.DESCRIPTION_INPUT} className="field description-input">
					<label>
						<Trans i18nKey="updatejobs.create.description">Description (optional)</Trans>
					</label>
					<textarea
						placeholder={descriptionPlaceholder}
						data-testid="job-details-form-description"
						value={formData.description as string}
						onChange={(event) => setFormData({...formData, description: event.target.value})}
					/>
				</div>
			</div>
		</>
	);
};

export default JobDetailsForm;
